"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __importDefault(require("tsdom"));
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("@main/constants");
var webAgent = function () {
    var _a;
    var instance = axios_1.default.create();
    var csrfToken = tsdom_1.default('meta[name="csrf-token"]').attr('content');
    instance.defaults.headers.common = (_a = {},
        _a[constants_1.XML_HTTP_REQUEST_WITH] = constants_1.XML_HTTP_REQUEST,
        _a[constants_1.XML_CSRF_TOKEN] = csrfToken,
        _a);
    return instance;
};
exports.default = webAgent;
